/*
 * Copyright (c) 2021 EGT Digital - All rights reserved.
 *
 * File: SearchSectionPlaceholder.tsx
 *
 * Written by Yuliyan Milenkov <yuliyan.milenkov@egt-digital.com> on  28.10.22 12:44 pm.
 * Last modified: 28.10.22 12:44 pm.
 *
 * More information at: https://egt-digital.com/
 */
import React from 'react';
import { addBuildHash } from '../api/helpers';
import { useLobbyHost } from '../contexts/SettingsContext';
import { useTranslator } from '../contexts/TranslatorContext';

const SearchSectionPlaceholder = () => {
    const host = useLobbyHost();
    const translate = useTranslator();

    return (
        <div className="egt_search_section_placeholder">
            <img src={addBuildHash(`${host}/assets/portal/ui/srch.svg`)} alt="Search" />
            <br />
            <div>{translate('searchNoEntry')}</div>
        </div>
    );
};

export default SearchSectionPlaceholder;
